module.exports = __webpack_public_path__ + "fonts/visuelt-pro-bold.14d378bf.ttf";